import { Component, Input } from '@angular/core';

import { CustomClipboard } from './../../../core/services/clipboard/clipboard.service';
import { SnackbarService } from 'src/app/shared/components/snackbar/service/snackbar.service';

interface Item {
  email: string;
  cellphone: string;
}

@Component({
  selector: 'app-contact-component',
  styleUrls: [`./contact.component.scss`],
  templateUrl: './contact.component.html'
})
export class ContactComponent {
  
  @Input() item: Item;

  constructor(
    private snackService: SnackbarService,
    private clipboard: CustomClipboard
  ) { }


  public copyToClipboard(ev: Event, item: string, type: string): Promise<void> {
    ev.stopPropagation();
    ev.preventDefault();
    return this.clipboard.writeText(item).then(() => {
      this.snackService.show(`${type} copiado`, 'success');
    });
  }


}
